import { isEmpty, get } from 'lodash';
import {
  MEDIA_TYPES,
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_VIDEO,
  NODE_TYPES_SUPPORT_INPUT_SIZES,
} from '../../constants';
import {
  QUESTION_MATRIX_OPEN_ENDED_STYLES,
  QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES,
  QUESTION_MATRIX_OPEN_ENDED_CLASSES,
} from '../QuestionBody/Matrix/MatrixOpenEnded/constants';

export const transformMediaQuestionAttributes = (options) => {
  const {
    image_url: imageURL,
    optimized_image_url: optimisedImageURL,
    video,
    media,
    refId,
    questionRefId,
  } = options;
  const isEmptyMedia = isEmpty(media);
  let type;
  let source;
  let thumbnail;
  let mediaQuestionRefId;
  let disableControl = false;
  if (imageURL) {
    type = MEDIA_TYPE_IMAGE;
    source = imageURL;
    thumbnail = optimisedImageURL || imageURL;
    mediaQuestionRefId = questionRefId;
  } else if (video) {
    source = video.src;
    thumbnail = video.poster;
    ({ disableControl, type = MEDIA_TYPE_VIDEO } = video);
    mediaQuestionRefId = questionRefId;
  } else if (!isEmptyMedia && MEDIA_TYPES.includes(media.type)) {
    source = media.url;
    ({ type, thumbnail, disableControl } = media);
    mediaQuestionRefId = questionRefId;
  }
  return {
    type,
    source,
    thumbnail,
    mediaQuestionRefId,
    disableControl,
    refId,
  };
};

export function getAnswersWrapperClassName(node) {
  const base = 'answers-wrapper';

  if (!NODE_TYPES_SUPPORT_INPUT_SIZES.includes(node.style)) {
    return base;
  }

  const { style, inputSize } = get(node, 'matrix.openEndedConfig', {});

  if (style === QUESTION_MATRIX_OPEN_ENDED_STYLES.VERTICAL) {
    const size =
      QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES[inputSize] ||
      QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES.FULL_WIDTH;

    return `${base} ${base}-vertical-${QUESTION_MATRIX_OPEN_ENDED_CLASSES[size]}`;
  }

  return base;
}
